"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _LiveRegionBlock = require("./LiveRegionBlock");
var _interfaces = require("./interfaces");
var _core = require("@emotion/core");
var Announcer = function Announcer(_ref) {
  var politeLogRegion = _ref.politeLogRegion,
    politeStatusRegion = _ref.politeStatusRegion,
    assertiveLogRegion = _ref.assertiveLogRegion,
    assertiveStatusRegion = _ref.assertiveStatusRegion;
  return (0, _core.jsx)("div", null, (0, _core.jsx)(_LiveRegionBlock.LiveRegionBlock, {
    "aria-live": "assertive",
    role: _interfaces.LiveRegionRole.Status
  }, assertiveStatusRegion), (0, _core.jsx)(_LiveRegionBlock.LiveRegionBlock, {
    "aria-live": "assertive",
    role: _interfaces.LiveRegionRole.Log
  }, assertiveLogRegion), (0, _core.jsx)(_LiveRegionBlock.LiveRegionBlock, {
    "aria-live": "polite",
    role: _interfaces.LiveRegionRole.Status
  }, politeStatusRegion), (0, _core.jsx)(_LiveRegionBlock.LiveRegionBlock, {
    "aria-live": "polite",
    role: _interfaces.LiveRegionRole.Log
  }, politeLogRegion));
};
var _default = Announcer;
exports.default = _default;